import TablePage from './table.vue';

export default TablePage;
